import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, Type, ViewChild, ViewChildren } from '@angular/core';
import { AnaSoggettoComponent } from '../ana-soggetto/ana-soggetto.component';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NicaFormComponent } from '../../components/nica-form/nica-form.component';
import { NicaDynamicContentComponent } from '../../components/nica-dynamic-content/nica-dynamic-content.component';
import { NicaAnagraficaComponent } from '../../components/nica-anagrafica/nica-anagrafica.component';
import { alert, confirm } from 'devextreme/ui/dialog';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { Apiservice } from '../../services/api.service';
import { NewNicaFormComponent } from '../../components/nica-form/new-nica-form.component';


@Component({
  selector: 'app-automezzo',
  templateUrl: './ana-automezzo.component.html',
  styleUrls: ['./ana-automezzo.component.css']
})
export class AnaAutomezzoComponent extends NicaMaster implements OnInit {
  @ViewChild('formSoggetto', { static: false }) formSoggetto: NicaFormComponent;
  @ViewChild('formAnagrafica', { static: false }) formAnagrafica: NewNicaFormComponent;
  @ViewChild('dynamicComponent', { static: false }) dynamicComponent: NicaDynamicContentComponent;
  @ViewChild('nicaAnagrafica', { static: false }) nicaAnagrafica: NicaAnagraficaComponent;

  @Input() itemData: any
  @Input() InviaA: any
  @Output() onAllEvent: EventEmitter<any> = new EventEmitter<any>();
  autorTabs: any[];
  templateTab: any = {
    automezzo: 'grid',
    AlboAutomezzo: 'grid',

  }
  selectedIndex: any =
    {
      automezzo: 0,
      AlboAutomezzo: 1,

    }


  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public loader: NgxSpinnerService,
    public formservice: FormsTemplateService,
    public apiService: Apiservice
  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService

    );


  }


  ngOnInit(): void {

    if (this.itemData) {
      this.setGlobalVariableFromParams(this.itemData[0])
      this.setTabsAutomezzi(this.itemData[0]);
    } else {
      this.activatedroute.queryParams.subscribe((params) => {
        console.log(" ecco i paramentri in automezzo ", params)

        this.setGlobalVariableFromParams(params)


        if (this.SubjectCall == 'AlboAutomezzo') {
          this.SetToolbarButtons(this.serviceButtonsArray, this.filterID, null, null, true);


        }


        this.setTabsAutomezzi(params);



      })


    }


  }


  ngAfterViewInit(): void {

    if (this.SubjectCall == 'AlboAutomezzo') {


      if (this.template == 'grid') {
        if (this.filterID['isScarrabile']) {
          this.nicaAnagrafica.griglia.instance.columnOption('listaCarrozzeriaAlboGeneric', 'visible', true);
          this.nicaAnagrafica.griglia.instance.columnOption('listaCer', 'visible', false);
          this.nicaAnagrafica.griglia.instance.columnOption('idCategoriaAlbo', 'width', '150px');
          this.nicaAnagrafica.griglia.instance.columnOption('listaCarrozzeriaAlboGeneric', 'width', '100px');


        } else {
          this.nicaAnagrafica.griglia.instance.columnOption('listaCarrozzeriaAlboGeneric', 'visible', false);
          this.nicaAnagrafica.griglia.instance.columnOption('listaCer', 'visible', true);


          this.nicaAnagrafica.griglia.instance.columnOption('idCategoriaAlbo', 'width', '150px');
          this.nicaAnagrafica.griglia.instance.columnOption('listaCer', 'width', '100px');
        }


      }
    }
  }

  setTabsAutomezzi(param) {

    this.selectedIndex[this.SubjectCall];


    this.autorTabs = [
      {
        name: 'Anagrafica Automezzo',
        icon: 'glyphicon icon-autorizzazioni-form',
        hint: 'gestione automezzi trasportatore',
        displayMode: 'in-line',
        path: 'main/anagrafica-automezzo',
        componentName: 'AnaAutomezzoComponent',
        service: 'automezzo',
        api: 'Automezzo',
        templateComponent: this.templateTab['automezzo'],
        visible: true,
        disabled: false
      },
      {
        name: 'Categoria Automezzo',
        icon: 'glyphicon icon-categoria-albo-gestore',
        hint: 'Autorizzazioni Area',
        displayMode: 'in-line',
        path: 'main/anagrafica-automezzo',
        componentName: 'AnaAutomezzoComponent',
        service: 'AlboAutomezzo',
        api: 'AlboAutomezzo',
        templateComponent: this.templateTab['AlboAutomezzo'],
        visible: true,
        disabled: this.filterID['idAutomezzo'] > 0 ? false : true
      }

    ]

  }

  tabClick(ev) {


    const itemData = ev.itemData;

    if (itemData.service == this.SubjectCall) {

      return
    }

    let data = [];

    if (this.template == 'form') {
      const validation = this.formAnagrafica.validate();
      if (validation.isValid) {

        this.formAnagrafica.onFormSubmit();
      } else {
        this.selectedIndex[this.SubjectCall];
        return
      }
    }

    setTimeout(() => {

      switch (this.SubjectCall) {
        /*
          
          Quando Sono nella TAB AlboCategoria devo passare i dati alle altre tab.
          il dato costante da inviare è alle tab relazionate id ovvero idAlboCategoria
    
        */


        case 'automezzo':


          data = this.formAnagrafica.dataSet;

          this.filterID['idAutomezzo'] = data['id'];

          /*
            Se la tab AlboAutomezzo è già stata visitata verifico se è in modalità form e se nei filtri è prensete l'id idCategoriaAutomezzo,
            Se presente lo setto per visualizzare i dati della Form in AlboCarrozzeriaMobile
          */

          if (this.filterID['idCategoriaAutomezzo'] && this.filterID['templateTab']['AlboAutomezzo'] == 'form') {
            data['id'] = this.filterID['idCategoriaAutomezzo'];
            this.filterID['isEdit'] = true;
            
          }


          /**Controllo l'Oggetto templateTab  se risulta definito gli associo il template Attuale della tab AlboCategoria 
           altrimenti setto  l'oggetto con la varibile templateTab dove sono definiti i valori di default delle due tab **/

          if (typeof this.filterID['templateTab'] != 'undefined') {
            this.filterID['templateTab']['automezzo'] = this.template
          } else {
            this.filterID['templateTab'] = this.templateTab;
            this.filterID['templateTab']['automezzo'] = this.template
          }


          this.templateTab['automezzo'] = this.template

          break;


        case 'AlboAutomezzo':
          /*
          Quando Sono nella TAB AlboAutomezzo devo passare i dati alle altre tab.
          il dato costante da inviare è idAutomezzo, tuttavia se ritorno sulla tab Automezzo 
          devo ritornare sulla Form ed il mio campo costante è id che nelle altre tab è  settato come idAutomezzo
          Inoltre setto anche idCategoriaAutomezzo, in modo da poterlo conservare e inviarlo nuovamente alla tab AlboAutomezzo 
          se sono in visualizzazione form così da avere di nuovo il dettaglio della CategoriaAutoemzzo già visualizzata.
          */

          if (this.template == 'form') {
            data = this.formAnagrafica.dataSet;
            this.filterID['idCategoriaAutomezzo'] = data['id'];
            this.filterID['isEdit'] = true
          } else {
            data = this.filterID
            this.filterID['idCategoriaAutomezzo'] = data['idCategoriaAutomezzo'];
            this.filterID['isEdit'] = true
          }

        

          data['id'] = data['idAutomezzo'];
          this.filterID['idAutomezzo'] = data['idAutomezzo'];

          this.templateTab['AlboAutomezzo'] = this.template

          this.filterID['templateTab']['AlboAutomezzo'] = this.template
          break;
      }



      this.refreshPage(data, '', itemData.service, this.filterID['templateTab'][itemData.service], itemData);



    }, 500);



    return







  }

  onOptionChanged(ev) {

  }

  rowGridSel(ev) {

    if (this.SubjectCall == 'automezzo' && this.template == 'grid') {
      this.filterID['idAutomezzo'] = ev.id;
      const data = this.filterID;
      this.refreshPage(data, 'Elenco', this.SubjectCall, 'grid');
    }

  }

  formButtonEvent(e) {


    if (e.name == 'return') {

      this.formEvent(e)
    }


    if (e.name == 'submittedInsertOk' || e.name == 'submittedEditOk') {

      let data = e.formData;

      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });


      }
      if (typeof this.filterID['templateTab'] == 'undefined') {
        this.filterID['templateTab'] = this.templateTab;
      }
      this.filterID['templateTab'][this.SubjectCall] = this.template;

      if (this.SubjectCall == 'AlboAutomezzo') {
        this.filterID['idAutomezzo'] = data['idAutomezzo'];
      }

      if (this.SubjectCall == 'AlboAutomezzo') {
        this.filterID['templateTab']['AlboAutomezzo'] = 'grid';
      }

      this.filterID['isEdit'] = true

      this.refreshPage(data, '', this.SubjectCall, this.filterID['templateTab'][this.SubjectCall]);
      return

    }



  }


  formGridEvent(e) {

    let eventName = e.infoEventButtons
    if (this.SubjectCall == 'AlboAutomezzo' && eventName == 'CopiaCerDaAlboCarrozzeria') {

      this.eventmitterCerDaAlboCarrozzeria(e)
    }

    if (this.SubjectCall == 'AlboAutomezzo' && eventName == 'CopiaCerDaCategoriaAutomezzo') {

      this.eventmitterCerDaCategoriaAutomezzo(e)
    }


  }

  formInitializzedAutomezzi(event) {
    if (this.SubjectCall == 'AlboAutomezzo') {
      const form = event.component


      if (!this.filterID['isScarrabile']) {

        //form.itemOption('datiCategorie.listaCarrozzeriaAlboGeneric', 'cssClass', 'd-none');
        form.itemOption('datiCategorie.listaCarrozzeriaAlboString', 'cssClass', 'd-none');
      }

      if (this.filterID['isScarrabile']) {
        form.itemOption('datiListaCer.listaCer', 'cssClass', 'd-none');
        form.itemOption('datiListaCer', 'cssClass', 'd-none');
      }




    }
    this.SetToolbarButtons(this.serviceButtonsArray);

  }


  eventmitterCerDaAlboCarrozzeria(e) {

    let height = 500;
    let queryString = ''
    const id = this.formAnagrafica.dataSet.id;
    const idCategoriaAlboGestore = this.formAnagrafica.dataSet.idCategoriaAlbo;
    if (typeof idCategoriaAlboGestore != 'undefined') {
      const idSede = this.filterID['idSede']
      queryString = `/${idSede}?$filter=((idCategoriaAlboGestore eq '${idCategoriaAlboGestore}'))`;
      // AGGIUNTO
      queryString = `/${idSede}`
    } else {
      // AGGIUNTO
      const idSede = this.filterID['idSede']
      queryString = `/${idSede}?$filter=((idCategoriaAlboGestore eq '${idCategoriaAlboGestore}'))`;
      queryString = `/${idSede}`
      //SOSTITUITO
      //alert('Seleziona la Categoria Albo Gestore ', 'Attenzione!');
      //return
    }









    let instancedDataGrid = {
      api:'AlboCategoria',
      service: null,
      remoteOperation: true,
      rowAlternate: true,
      queryString: queryString,
      isEditable: false,
      isEditableNewRow: false,
      isEditableEditRow: false,
      isEditableDeleteRow: false,
      tableHeight: 500,
      tableWidth: 600,
      showFilter: false,
      colonne: [
        {
          type: 'campoSpecial',
          dataField: "idCategoriaAlboGestore",
          caption: "Cat.Albo",
          dataType: "",
          colWidth: '550',
          colVisible: true,
          lista: {
            dataSource: 'CategoriaAlboGestore',
            valueExpr: 'id',
            displayExpr: 'descrizione',
            static: false,
          }
        },

      ],

      selectionRowMode: 'single',
      selectedData: null,
      isOdata: false,
      idTable: 'CarrozzeriaAlboGestore',
      showToolbarTop: false,
      showToolbarBottom: false,
      isSearchable: false,

    }



    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, 'NicaDataGridComponent', null, '600', null, instancedDataGrid, true, true, 'Elenco categorie albo');
    this.userComponentService.outputComponent.subscribe(currentOutput => {

      console.log('currentOutput', currentOutput)

      if (currentOutput.name == "onRowSelectionChange" && guid == currentOutput.guid) {
        if (this.filterID['isEdit']) {
          let e = currentOutput;
          const idAlboCategoriaOrigine = e.data.id
          const idCategoriaAutomezziDestinazione = id;

          let api = this.apiset + `/CopiaCerDaAlboCategoria?IdAlboCategoriaOrigine=${idAlboCategoriaOrigine}&IdCategoriaAutomezziDestinazione=${idCategoriaAutomezziDestinazione}`;
          confirm('Eventulai EER già presenti verranno rimossi proseguire?', 'Attenzione!').then(resp => {
            if (!e.data && idAlboCategoriaOrigine) {
              this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
              return
            } else {
              this.anagraficaService.actionInsert(api, []).then(res => {
                if(!res['listaCer']){
                  alert('Nessun E.E.R. disponibile','Attenzione!');
                  return
                }
                this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)

                this.refreshPage(this.formAnagrafica.dataSet, '', this.SubjectCall, this.template)
              })
            }



          })
        } else {

          const listaCer = currentOutput.data.listaCer;
          if(listaCer.length == 0){
            alert('Nessun E.E.R. disponibile','Attenzione!');
            //this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
            return
          }
          this.formAnagrafica.formRefreshInputData('listaCer', listaCer)                  
          setTimeout(() => {
            this.formAnagrafica.renderForm();
          }, 200);
          this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
        }


      }

    })
    return



  }


  eventmitterCerDaCategoriaAutomezzo(e) {

    let height = 500;

    const idCategoriaAlbo = this.formAnagrafica.dataSet.idCategoriaAlbo;
    if (idCategoriaAlbo === null) {

      this._overlaySidePanelService.close();
      alert('Seleziona la Categoria Albo Gestore ', 'Attenzione!');
      return
    }
    let filterIDCategoriaAutomezzo = ''
    const id = this.formAnagrafica.dataSet.id;
    if (this.filterID['isEdit']) {

      filterIDCategoriaAutomezzo = `(id ne ${id}) and `;
    }
    let queryStringDetail = `?$filter=${filterIDCategoriaAutomezzo}(idCategoriaAlbo eq '${idCategoriaAlbo}')`;


    const idSede = this.filterID['idSede'];

    const idAutomezzo = this.formAnagrafica.dataSet.idAutomezzo;
    let filterId = ''

    //Controlla QUERY 
    filterId = `(id lt ${idAutomezzo})`;


    let queryString = `?idCategoriaAbo=${idCategoriaAlbo}&IdEscludiAutomezzo=${idAutomezzo}`;
    let dataFilter = {
      idSede:idSede
    }
    let instancedDataGrid = {
      service: null,
      api: 'CategoriaAutomezzo/GetListaAutomezziByCategoria',
      remoteOperation: true,
      rowAlternate: true,
      queryString: queryString,
      isEditable: false,
      isEditableNewRow: false,
      isEditableEditRow: false,
      isEditableDeleteRow: false,
      tableHeight: 500,
      tableWidth: 600,
      dataJson:dataFilter,
      showFilter: false,
      colonne: [
        {
          type: 'campo', dataField: "targaAutomezzo", caption: "Nr. Targa",
          colWidth: 100
        },
        {
          type: 'campo', dataField: "descrAutomezzo",
          caption: "Descrizione", colWidth: 400
        },
        {
          type: 'campo', dataField: "descrCategoriaAlbo",
          caption: "Cat.Albo", colWidth: 70
        },


      ],

      selectionRowMode: 'single',
      selectedData: null,
      isOdata: true,
      idTable: 'CategoriaAutomezzoCer',
      showToolbarTop: false,
      showToolbarBottom: false,
      isSearchable: false,
     
    }

    let title = "Lista Automezzi Cat.Albo " + idCategoriaAlbo

    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, 'NicaDataGridComponent', null, '600', null, instancedDataGrid, true, true, title);
    this.userComponentService.outputComponent.subscribe(currentOutput => {



      if (currentOutput.name == "onRowSelectionChange" && guid == currentOutput.guid) {

        console.log('onRowSelectionChange-->',currentOutput)
        let data = currentOutput.data
        if(!data.listaCer){
          alert('Nessun E.E.R. disponibile','Attenzione!');
          //this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
          return
        }
        confirm('Eventulai EER già presenti verranno rimossi proseguire?', 'Attenzione!').then(resp => {
          if (!resp) {
            //this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
            return
          } else {
            if (this.filterID['isEdit']) {

              const idAutomezzoCategoriaOrigine = data.idCategoriaAlbo
              const idCategoriaAutomezziDestinazione = id;

              let api = this.apiset + `/CopiaCerDaAutomezzo?idCategoriaAutomezzi=${idAutomezzoCategoriaOrigine}&idCategoriaAutomezziDestinazione=${idCategoriaAutomezziDestinazione}`;



              this.anagraficaService.actionInsert(api, []).then(res => {
                this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)

                this.refreshPage(this.formAnagrafica.dataSet, '', this.SubjectCall, this.template)
              })

            } else {
              const listaCer = data.listaCer;

              if(!listaCer){
                alert('Nessun E.E.R. disponibile','Attenzione!');
                return 
              }

              this.formAnagrafica.formRefreshInputData('listaCer', listaCer)

              this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
            }
          }

        })


      }
    })

    

   

  }
}
